import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFieldYesNo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.13481 11.8477L1.69531 7.40823L3.4461 5.65745L6.10355 8.31489L11.4184 3L13.1692 4.78205L6.13481 11.8477Z",
			fill: "#9C9EB6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7344 11.2371L12.9658 13.0056L20.9243 20.9642L22.6929 19.1956L14.7344 11.2371Z",
			fill: "#9C9EB6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.9219 11.2371L22.6904 13.0056L14.7319 20.9642L12.9633 19.1956L20.9219 11.2371Z",
			fill: "#9C9EB6"
		})
	]
});
export default SvgFieldYesNo;
